import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { Pagination } from 'dw-contentful-components';
import { Section } from '../components/Section';
import { HeroBannerWrapper } from '../components/HeroBannerWrapper';
import standardiseContentfulId from '../util/standardiseContentfulId';
import { ButtonTabs } from 'dw-uk-common';
import getBrand from "dw-brand-identify";
import getGlobalCssForBrand from '../util/getGlobalCssForBrand';
import '../styles/index.scss';

const props = {
  pageContext: PropTypes.object,
  data: PropTypes.object,
};

const defaultProps = {
  pageContext: {
    brand: 'law',
    pageData: {
      sections: [],
    },
    pagination: [],
  },
  data: {},
};

const Page = ({ pageContext, data: brandData }) => {
  const { brand, pageData, pagination } = pageContext;
  const paginatedItems = pagination?.items;
  const seoMeta = pageData?.seoMeta || {};

  useEffect(() => {
    removeEmptyDescription();
  }, []);

  const removeEmptyDescription = () => {
    if (typeof window !== "undefined") {
      document.head.querySelectorAll("meta[name='description']").forEach(meta => {
        if (!meta.getAttribute("content") || meta.getAttribute("content") == "vineyards") {
          meta.remove();
        }
      });
      document.body.querySelectorAll("meta[name='description']").forEach(meta => {
        if (!meta.getAttribute("content") || meta.getAttribute("data-react-helmet") == "true") {
          meta.remove();
        }
      });
    }
  }

  if (paginatedItems) {
    const folio = pageData.sections.find(
      ({ __typename }) => __typename === 'ContentfulReferenceCardSection',
    );

    folio.referenceCards = paginatedItems;
  }
  const brandName = getBrand().displayName;
  const getDescription = () => {
    return `${seoMeta?.seoDescription}`.replace("{title}", seoMeta?.seoTitle || "") || "";
  }

  return (
    <div className={`vineyard-page cms ${brand}`} id={standardiseContentfulId('top')}>
      <Helmet>
        {process.env.NODE_ENV === 'development' && (
          <link rel="stylesheet" href={getGlobalCssForBrand(brand)} />
        )}
        <link
          rel="stylesheet"
          href="//maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css"
        />
        {
          seoMeta?.seoTitle &&
          <title>{`${seoMeta?.seoTitle} - ${brandName}`}</title>
        }
        {
          seoMeta?.seoDescription &&
          <meta name="description" content={getDescription()} data-helmet-tag="true" />
        }
      </Helmet>
      <HeroBannerWrapper brand={brand} heroBanner={pageData?.heroBanner} variant={1} />
      <ButtonTabs />
      {pageData.sections.map((section) => (
        <Section
          key={section.id}
          brand={brand}
          data={section}
          backButton={!!paginatedItems}
        />
      ))}
      {paginatedItems && (
        <Pagination
          current={pagination.current}
          total={pagination.total}
          next={pagination.next}
          prev={pagination.prev}
        />
      )}
    </div>
  );
};

Page.propTypes = props;
Page.defaultProps = defaultProps;

export default Page;